<script>
import {
  pageMonCompteToutesMesCommandesProps,
  usePageMonCompteToutesMesCommandes
} from "./mixin";
import List from "@/components/molecules/list";
import ListItem from "@/components/molecules/list/list-item";
import CommandeOverview from "@/components/organisms/mon-compte/commande-overview/default";
import FormSelect from "@/components/molecules/form-select";
import FormSelectOption from "@/components/molecules/form-select/form-select-option";
import FormGroup from "@/components/molecules/form-group";
import ButtonIcon from "@/components/molecules/button-icon";
import Titre from "@/components/atoms/titre";

export default {
  name: "ToutesMesCommandes",
  components: {
    List,
    ListItem,
    CommandeOverview,
    FormSelect,
    FormGroup,
    FormSelectOption,
    ButtonIcon,
    Titre
  },
  props: {
    ...pageMonCompteToutesMesCommandesProps()
  },
  setup(props) {
    const {
      filterType,
      sortType,
      allYears,
      filteredCommandes,
      commandesByYear,
      noCommandesToDisplay,
      filter,
      sort
    } = usePageMonCompteToutesMesCommandes(props);

    return {
      filterType,
      sortType,
      allYears,
      filteredCommandes,
      commandesByYear,
      noCommandesToDisplay,
      filter,
      sort
    };
  }
};
</script>

<template>
  <div>
    <ButtonIcon
      link
      variant="text"
      no-underline
      icon-name="arrow-left"
      icon-size="sm"
      to="/mon-compte/mes-commandes"
    >
      Retour
    </ButtonIcon>
    <Titre
      tag="h1"
      variant="primary"
      size="md"
      class="u-mb-md u-mt-md"
    >
      Toutes mes commandes ({{ commandes.length }})
    </Titre>

    <div class="u-flex u-flex-justify-between u-mb-md">
      <FormGroup>
        <label
          for="periodeCommandes"
          class="u-block u-font-13 u-mb-xs"
        >
          Période :
        </label>
        <FormSelect
          id="periodeCommandes"
          v-model="filterType"
          size="sm"
        >
          <FormSelectOption value="fixed-all">
            Toutes mes commandes
          </FormSelectOption>
          <FormSelectOption value="fixed-month">
            Ce mois-ci
          </FormSelectOption>
          <FormSelectOption value="fixed-3months">
            Les 3 derniers mois
          </FormSelectOption>
          <FormSelectOption value="fixed-6months">
            Les 6 derniers mois
          </FormSelectOption>
          <FormSelectOption
            v-for="year in allYears"
            :key="`filter-${year}`"
            :value="year"
          >
            En {{ year }}
          </FormSelectOption>
        </FormSelect>
      </FormGroup>

      <FormGroup>
        <label
          for="triCommandes"
          class="u-block u-font-13 u-mb-xs"
        >
          Trier par :
        </label>
        <FormSelect
          id="triCommandes"
          v-model="sortType"
          size="sm"
        >
          <FormSelectOption value="date_desc">
            Date : de la plus récente à la plus ancienne
          </FormSelectOption>
          <FormSelectOption value="date_asc">
            Date : de la plus ancienne à la plus récente
          </FormSelectOption>
          <FormSelectOption value="montant_desc">
            Montant : du + élevé au - élevé
          </FormSelectOption>
          <FormSelectOption value="montant_asc">
            Montant : du - élevé au + élevé
          </FormSelectOption>
        </FormSelect>
      </FormGroup>
    </div>
    <template v-if="sortType === 'date_desc' || sortType === 'date_asc'">
      <div
        v-for="year in commandesByYear"
        :key="year.year"
      >
        <template v-if="year.commandes.length > 0">
          <Titre
            tag="h2"
            size="sm"
            class="u-mb-sm"
          >
            {{ year.year }}
          </Titre>
          <List class="u-mb-md">
            <ListItem
              v-for="commande in year.commandes"
              :key="commande.id"
              class="u-mb-sm"
            >
              <CommandeOverview :commande="commande" />
            </ListItem>
          </List>
        </template>
      </div>
    </template>
    <template v-else>
      <List class="u-mb-md">
        <ListItem
          v-for="commande in filteredCommandes"
          :key="commande.id"
          class="u-mb-sm"
        >
          <CommandeOverview :commande="commande" />
        </ListItem>
      </List>
    </template>
    <template v-if="noCommandesToDisplay">
      <p>
        Vous n'avez aucune commandes
        <template v-if="filterType === 'fixed-month'">
          ce mois-ci.
        </template>
        <template v-else-if="filterType === 'fixed-3months'">
          ces 3 derniers mois.
        </template>
        <template v-else-if="filterType === 'fixed-6months'">
          ces 6 derniers mois.
        </template>
        <template v-else>
          correspondant à ces critères de recherche.
        </template>
      </p>
    </template>
  </div>
</template>

<style lang="scss" scoped>
</style>
